import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class Auth0LinkingHttpService {
    constructor(http) {
        this.http = http;
        this.base = 'core-api/Ticketing/Identity/customer/auth0';
    }
    initiate(emailToLink) {
        return this.http.post(`${this.base}/initiate-link`, { emailToLink: emailToLink || null });
    }
    confirm(linkingSessionId, otp) {
        return this.http.post(`${this.base}/confirm-link`, { linkingSessionId, otp });
    }
    // Links directly to the customer that owns the Auth0-verified profile email, no OTP. The email is
    // taken server-side from the validated token, so there is nothing to send in the body.
    linkVerified() {
        return this.http.post(`${this.base}/link-verified`, {});
    }
    // Creates a brand-new customer for the current (unlinked) Auth0 identity and links it.
    // The email is taken server-side from the Auth0-verified token, never from this payload.
    createAndLink(payload) {
        return this.http.post(`${this.base}/create-and-link`, payload);
    }
    // Returns whether a customer with the given email already exists in the current portal,
    // so the UI can decide whether to offer "link this existing account".
    checkExistingCustomer(email) {
        return this.http.post(`${this.base}/check-existing-customer`, { email: email || null });
    }
}
Auth0LinkingHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function Auth0LinkingHttpService_Factory() { return new Auth0LinkingHttpService(i0.ɵɵinject(i1.HttpClient)); }, token: Auth0LinkingHttpService, providedIn: "root" });
